export enum SignInChallenges {
  NewPasswordRequired = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
  Done = 'DONE',
}
